import React from 'react';
import { AdminTrainingPanel } from './admin/AdminTrainingPanel';
import { SellerTrainingView } from './seller/SellerTrainingView';

interface TrainingSectionProps {
  isAdmin: boolean;
}

export const TrainingSection: React.FC<TrainingSectionProps> = ({ isAdmin }) => {
  if (isAdmin) {
    return <AdminTrainingPanel />;
  }

  return <SellerTrainingView />;
};

export default TrainingSection;
